<template>
  <div></div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    methods: mapActions({
      logout: 'skiliko/session/logout'
    }),
    mounted () {
      this.logout()
        .then(_ => this.$router.replace('/'))
        .then(() => location.reload())
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue